@if (!session.loading()) {
  <div id="hunt-package-details-page-wrapper">
    <div class="page-header">
      <div class="left">
        <hyperkit-breadcrumb-list
          class="breadcrumb-list"
          [items]="breadcrumbs()"
        ></hyperkit-breadcrumb-list>
        <hyperkit-typography variant="h2">
          {{ activeHuntPackage()?.title }}
        </hyperkit-typography>
        <div class="meta-data-tags">
          @if (pkgView.severity()) {
            <hyperkit-badge
              [variant]="pkgView.severityVariant()"
              size="base"
              indicator="none"
              icon="check"
              [text]="pkgView.severity()"
            ></hyperkit-badge>
          }
          @if (pkgView.isCustom()) {
            <hyperkit-badge
              variant="information"
              size="base"
              indicator="none"
              icon="check"
              text="Custom"
            ></hyperkit-badge>
          }
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Created"
            [text]="pkgView.createdDate()"
          ></hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Author"
            [text]="pkgView.author()"
          ></hyperkit-tag>
        </div>
      </div>
      <div class="right">
        <hyperkit-button
          variant="standard"
          color="secondary"
          size="small"
          text="Back to Hunt"
          [routerLink]="['/hunt', nav.huntId(), 'workbench']"
          icon="arrow-left"
          iconPosition="left"
        ></hyperkit-button>
        <hyperkit-button
          variant="standard"
          color="secondary"
          size="small"
          text="Continue to Reporting"
          icon="arrow-right"
          iconPosition="right"
          (click)="closeHunt()"
        ></hyperkit-button>
      </div>
    </div>
    <div class="page-content">
      <div id="hunt-packages">
        <div id="hunt-packages-header">
          <div id="hunt-package-title">
            <hyperkit-typography variant="h4" display="inline">
              Hunt Package
            </hyperkit-typography>
            <hyperkit-button
              variant="standard"
              color="tertiary"
              size="small"
              text="View Details"
              (click)="navigateToOverview()"
            ></hyperkit-button>
          </div>
          <div id="hunt-package-environment">
            <hyperkit-typography variant="emphasized" size="md"
              >Environment</hyperkit-typography
            >
            <div class="dropdown" id="environment-dropdown">
              <hyperkit-select
                [options]="environments()"
                valueProperty="id"
                displayProperty="name"
                placeholder="Select Environment"
                state="active"
                [ngModel]="selectedEnvironment()?.id"
                (ngModelChange)="nav.setSelectedEnvironmentId($event)"
                dropdownPosition="absolute"
              ></hyperkit-select>
            </div>
            <hyperkit-segmented-progress-bar
              [segments]="queryStatusSegments()"
              [showLabels]="true"
            ></hyperkit-segmented-progress-bar>
          </div>
          <div id="hunt-package-list">
            <div id="hunt-query-header">
              <hyperkit-typography variant="emphasized" size="md">
                Hunt Queries
              </hyperkit-typography>
            </div>
            @if (activeTools().length > 0) {
              @for (tool of activeTools(); track trackByTool($index, tool)) {
                <hunt-query-card
                  [tool]="tool"
                  [selectedQueryId]="nav.selectedQueryId()"
                ></hunt-query-card>
              }
            } @else {
              <div class="empty-state">
                No tools available for this environment.
              </div>
            }
          </div>
        </div>
      </div>
      <div id="hunt-package-details">
        <!-- Default view when no query is selected -->
        @if (!nav.selectedQueryId()) {
          <package-details-default-view></package-details-default-view>
        } @else {
          <package-details-query-selected-view />
        }
      </div>
      <div id="hunt-notes">
        @if (showTuning()) {
          <query-tuning> </query-tuning>
        } @else {
          <hunt-details-editor
            title="NOTES"
            height="calc(100vh - 170px)"
            [value]="huntView.notes()"
            (valueChange)="huntEdit.updateNotes($event)"
          ></hunt-details-editor>
        }
      </div>
    </div>
  </div>
} @else {
  <hyperkit-typography variant="body" size="sm"
    >Loading package…</hyperkit-typography
  >
}
